import { render, staticRenderFns } from "./Pets.vue?vue&type=template&id=2bc28063&scoped=true"
import script from "./Pets.vue?vue&type=script&lang=js"
export * from "./Pets.vue?vue&type=script&lang=js"
import style0 from "./Pets.vue?vue&type=style&index=0&id=2bc28063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc28063",
  null
  
)

export default component.exports